import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Spinner} from 'src/components/layout/loader/Spinner';
import {BookingActions, useBookingContext} from 'src/context/BookingContext';
import {UiProvider} from 'src/context/UiContext';
import {format} from 'src/lib/dates/format';
import {TimeSlotPicker} from '../../TimeSlotPicker/TimeSlotPicker';
import {useLocationDetailsContext} from 'src/context/LocationDetailsContext';

import './BookingTime.scss';
import {TimeSelectNextButton} from './TimeSelectNextButton';

export function BookingTime() {
    const {dispatch, bookingState} = useBookingContext();
    const {t} = useTranslation();

    const {
        locationDataState: {location, appointmentTypeIds}
    } = useLocationDetailsContext();
    const {selectedSlot, lockLoading, lockError} = bookingState.timeSlotState;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <UiProvider>
                <main className={`main-content booking-time-content`} id='main'>
                    <TimeSlotPicker
                        appointmentTypeIds={appointmentTypeIds}
                        locationId={location?.id as number}
                        initialSelectedSlot={selectedSlot || null}
                        reserveError={lockError}
                        lockLoading={lockLoading}
                        clearReserveError={() =>
                            dispatch({
                                type: BookingActions.SET_TIMESLOT_DATA,
                                value: {lockError: null, selectedSlot: null}
                            })
                        }
                        clearLoadError={() =>
                            dispatch({type: BookingActions.SET_TIMESLOT_DATA, value: {lockError: null}})
                        }
                        onTimeSlotClicked={(timeSlot: Date, selected: boolean) => {
                            if (selected) {
                                dispatch({
                                    type: BookingActions.SET_TIMESLOT_DATA,
                                    value: {
                                        selectedSlot: null
                                    }
                                });
                            } else {
                                dispatch({
                                    type: BookingActions.SET_TIMESLOT_DATA,
                                    value: {
                                        selectedSlot: timeSlot
                                    }
                                });
                            }
                        }}
                    />
                </main>
                <div
                    className='booking-time-content__mobile-nav'
                    role='region'
                    aria-label={t('timeSelect.aria_next_step_region')}
                >
                    <span>
                        {selectedSlot && (
                            <>
                                <span className='screen-reader-only'>
                                    {t('timeSelect.aria_selected_time_slot', {timeSlot: format(selectedSlot, 'Pp')})}
                                </span>
                                <span aria-hidden>{format(selectedSlot, 'ccc dd MMM, HH:mm').replace('.', '')}</span>
                            </>
                        )}
                    </span>

                    {lockLoading ? (
                        <div className='timeslot__spinner'>
                            <Spinner />
                        </div>
                    ) : (
                        <TimeSelectNextButton />
                    )}
                </div>
            </UiProvider>
        </>
    );
}
